import * as React from 'react';
import { QueryContext } from './QueryContext';

const QueryContextProvider = ({ children, value }) => (
    <QueryContext.Provider value={value}>{children}</QueryContext.Provider>
);

export default QueryContextProvider;
